import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./CommonBoard.css";

export default function Services() {
  const [posts, setPosts] = useState([]);
  const [viewType, setViewType] = useState("card");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchField, setSearchField] = useState("title");

  const [selectedPosts, setSelectedPosts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = viewType === "list" ? 10 : 6;
  const navigate = useNavigate();
  const paginatedPosts = posts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [viewType]);

  const renderPagination = () => {
    const totalPages = Math.ceil(posts.length / itemsPerPage);
    // if (totalPages <= 1) return null;

    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

    const buttonStyle = {
      padding: "6px 10px",
      border: "1px solid #ccc",
      borderRadius: "0px",
      fontSize: "14px",
      cursor: "pointer",
      backgroundColor: "white",
      color: "#000",
    };

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "30px",
          gap: "10px",
        }}>
        <button
          onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
          disabled={currentPage === 1}
          style={{
            ...buttonStyle,
            opacity: currentPage === 1 ? 0.5 : 1,
          }}>
          ◀
        </button>

        {pageNumbers.map((num) => (
          <button
            key={num}
            onClick={() => setCurrentPage(num)}
            style={{
              ...buttonStyle,
              backgroundColor: currentPage === num ? "#98bcc9" : "white",
              color: currentPage === num ? "white" : "#000",
            }}>
            {num}
          </button>
        ))}

        <button
          onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
          disabled={currentPage === totalPages}
          style={{
            ...buttonStyle,
            opacity: currentPage === totalPages ? 0.5 : 1,
          }}>
          ▶
        </button>
      </div>
    );
  };

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const isAdmin = sessionStorage.getItem("isAdmin") === "true";

  const fetchPosts = useCallback(() => {
    if (searchKeyword) {
      axios
        .get(
          `${baseUrl}/api/board/search?field=${searchField}&keyword=${encodeURIComponent(
            searchKeyword
          )}`
        )
        .then((res) => setPosts(res.data))
        .catch((err) => console.error("검색 실패:", err));
    } else {
      axios
        .get(`${baseUrl}/api/board`)
        .then((res) => setPosts(res.data))
        .catch((err) => console.error("게시글 불러오기 실패:", err));
    }
  }, [searchKeyword, searchField, baseUrl]);

  const handleSearch = () => {
    fetchPosts();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      fetchPosts();
    }
  };

  const handleDeleteSelected = async () => {
    if (selectedPosts.length === 0) {
      alert("삭제할 게시글을 선택하세요.");
      return;
    }

    if (!window.confirm("선택한 게시글을 삭제하시겠습니까?")) {
      return;
    }

    try {
      await axios.delete(`${baseUrl}/api/board`, {
        data: selectedPosts,
      });

      alert("삭제가 완료되었습니다.");
      setSelectedPosts([]);
      fetchPosts();
    } catch (err) {
      console.error("❌ 삭제 실패:", err);
      alert("삭제에 실패했습니다.");
    }
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedPosts([]);
    } else {
      setSelectedPosts(paginatedPosts.map((post) => post.board_number));
    }
    setSelectAll(!selectAll);
  };

  const toggleSelectPost = (boardNumber) => {
    if (selectedPosts.includes(boardNumber)) {
      setSelectedPosts(selectedPosts.filter((id) => id !== boardNumber));
    } else {
      setSelectedPosts([...selectedPosts, boardNumber]);
    }
  };

  useEffect(() => {
    axios
      .get(`${baseUrl}/api/board`)
      .then((res) => setPosts(res.data))
      .catch((err) => console.error("초기 게시글 불러오기 실패:", err));
  }, []);

  return (
    <div
      className="board-wrapper"
      style={{ maxWidth: "1000px", margin: "0 auto", padding: "40px 20px" }}>
      <div className="board-container">
        {/* 제목 + 버튼 */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}>
          <div style={{ fontSize: "24px", color: "#98bcc9" }}>게시판</div>

          <div className="view-toggle" style={{ display: "flex", gap: "16px" }}>
            <button
              onClick={() => setViewType("list")}
              style={{
                display: "inline-flex", // ✅ 버튼 내부 요소를 수평 정렬
                alignItems: "center", // ✅ 수직 정렬
                gap: "4px", // ✅ 간격
                background: "none",
                border: "none",
                cursor: "pointer",
                color: viewType === "list" ? "#98bcc9" : "#999",
                fontSize: "14px",
                padding: 0, // ✅ 버튼 기본 패딩 제거
              }}>
              <img
                src="/images/list-icon.png"
                alt="목록 아이콘"
                width={16}
                height={16}
                style={{
                  display: "inline-block",
                  verticalAlign: "middle", // ✅ 텍스트와 수평 맞추기 핵심
                }}
              />
              <span>목록보기</span>
            </button>

            <button
              onClick={() => setViewType("card")}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: viewType === "card" ? "#98bcc9" : "#999",
                fontSize: "14px",
                padding: 0,
              }}>
              <img
                src="/images/cards-icon.png"
                alt="카드 아이콘"
                width={13}
                height={13}
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
              />
              <span>카드보기</span>
            </button>
          </div>
        </div>

        <div
          style={{
            height: "1px",
            backgroundColor: "#eee",
            width: "100%",
            marginBottom: "20px",
          }}></div>

        {isAdmin && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginBottom: "20px",
            }}>
            <Link
              to="/board/new"
              style={{
                padding: "8px 12px",
                backgroundColor: "#98bcc9",
                color: "white",
                borderRadius: "0px",
                textDecoration: "none",
                fontSize: "14px",
              }}>
              글쓰기
            </Link>
            <button
              onClick={handleDeleteSelected}
              style={{
                padding: "8px 12px",
                backgroundColor: "#98bcc9",
                color: "white",
                borderRadius: "0px",
                border: "none",
                fontSize: "14px",
                cursor: "pointer",
              }}>
              선택 삭제
            </button>
          </div>
        )}

        {viewType === "list" ? (
          <>
            <table
              className="board-table"
              style={{ borderCollapse: "collapse", width: "100%" }}>
              <thead>
                <tr style={{ borderBottom: "2px solid #ccc" }}>
                  {isAdmin && (
                    <th style={{ textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={toggleSelectAll}
                      />
                    </th>
                  )}
                  <th style={{ padding: "12px 8px", textAlign: "center" }}>
                    번호
                  </th>
                  <th style={{ padding: "12px 8px", textAlign: "left" }}>
                    글제목
                  </th>
                  <th style={{ padding: "12px 8px", textAlign: "center" }}>
                    작성일
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedPosts.map((post, index) => {
                  const goToDetail = () =>
                    navigate(`/board/${post.board_number}`);

                  return (
                    <tr
                      key={post.board_number}
                      onClick={goToDetail}
                      style={{
                        borderBottom: "1px solid #ddd",
                        cursor: "pointer",
                      }}>
                      {/* 체크박스 (propagation 방지) */}
                      {isAdmin && (
                        <td style={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={selectedPosts.includes(post.board_number)}
                            onChange={(e) => {
                              e.stopPropagation(); // ✅ 상세페이지 이동 방지
                              toggleSelectPost(post.board_number);
                            }}
                            onClick={(e) => e.stopPropagation()} // iOS 등 일부 브라우저 대응
                          />
                        </td>
                      )}

                      {/* 번호 */}
                      <td style={{ padding: "12px 8px", textAlign: "center" }}>
                        {index + 1}
                      </td>

                      {/* 제목 – 텍스트로 처리 */}
                      <td style={{ padding: "12px 8px", color: "#000" }}>
                        {post.title}
                      </td>

                      {/* 작성일 */}
                      <td style={{ padding: "12px 8px", textAlign: "center" }}>
                        {post.date || "(작성일 없음)"}
                      </td>

                      {/* 수정 버튼 (propagation 방지) */}
                      {isAdmin && (
                        <td
                          style={{ padding: "12px 8px", textAlign: "center" }}>
                          <Link
                            to={`/board/edit/${post.board_number}`}
                            onClick={(e) => e.stopPropagation()} // ✅ 상세 이동 방지
                            style={{
                              padding: "4px 8px",
                              backgroundColor: "#4CAF50",
                              color: "white",
                              borderRadius: "0px",
                              textDecoration: "none",
                              fontSize: "12px",
                            }}>
                            수정
                          </Link>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        ) : (
          <div
            className="card-view"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
              gap: "24px",
              gridAutoRows: "1fr",
            }}>
            {paginatedPosts.map((post) => (
              <Link
                key={post.board_number}
                to={`/board/${post.board_number}`}
                className="card"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "260px",
                  border: "1px solid #ddd",
                  borderRadius: "0px",
                  padding: "20px",
                  backgroundColor: "#fff",
                  position: "relative",
                  cursor: "pointer",
                  transition: "box-shadow 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(0, 0, 0, 0.12)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                }}>
                {/* 수정 버튼 */}
                {isAdmin && (
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      zIndex: 1,
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // 카드 클릭 막기
                      e.preventDefault();
                      navigate(`/board/edit/${post.board_number}`); // 수동 이동
                    }}>
                    <button
                      style={{
                        padding: "6px 10px",
                        backgroundColor: "#4CAF50",
                        color: "#fff",
                        borderRadius: "0px",
                        fontSize: "12px",
                        border: "none",
                        cursor: "pointer",
                      }}>
                      수정
                    </button>
                  </div>
                )}

                {/* 제목 */}
                <button
                  to={`/board/${post.board_number}`}
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#222",
                    textDecoration: "none",
                    marginBottom: "8px",
                    textAlign: "left",
                  }}>
                  {post.title}
                </button>

                {/* 내용 (본문) */}
                <p
                  style={{
                    fontSize: "14px",
                    color: "#555",
                    lineHeight: "1.6",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 8,
                    WebkitBoxOrient: "vertical",
                  }}>
                  {post.content?.substring(0, 300)}
                </p>

                {/* ✅ 구분선: footer 고정 전 항상 같은 위치 */}
                <div
                  style={{
                    height: "1px",
                    backgroundColor: "#eee",
                    marginTop: "auto",
                    marginBottom: "16px",
                  }}
                />

                {/* 작성자 / 날짜 / 댓글 */}
                <div
                  style={{
                    fontSize: "13px",
                    color: "#999",
                    display: "flex",
                    justifyContent: "space-between",
                  }}>
                  <span>
                    {post.date || "날짜 없음"}
                    {typeof post.commentCount !== "undefined" && (
                      <> 💬 {post.commentCount}</>
                    )}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
        <div style={{ marginTop: "30px" }}>{renderPagination()}</div>
      </div>

      {/* 검색창 – 카드/리스트 공통 */}
      <div
        className="board-searchbar"
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          display: "flex",
          gap: "10px",
          justifyContent: "center",
        }}>
        <select
          value={searchField}
          onChange={(e) => setSearchField(e.target.value)}
          style={{
            padding: "6px",
            borderRadius: "0px",
            border: "1px solid #ccc",
            fontSize: "14px",
          }}>
          <option value="title">제목</option>
          <option value="content">내용</option>
        </select>
        <input
          type="text"
          value={searchKeyword}
          onChange={(e) => setSearchKeyword(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="검색어를 입력하세요"
          style={{
            padding: "6px",
            width: "280px",
            borderRadius: "0px",
            border: "1px solid #ccc",
            fontSize: "14px",
          }}
        />
        <button
          onClick={handleSearch}
          style={{
            padding: "6px 12px",
            borderRadius: "0px",
            backgroundColor: "#fff",
            cursor: "pointer",
            border: "1px solid #ccc",
            fontSize: "14px",
          }}>
          검색
        </button>
      </div>
    </div>
  );
}
